import React, { useState, useEffect } from 'react';

import { doc, setDoc, collection, getDocs } from 'firebase/firestore';
import Office from '../models/Office';
import { db } from '../Services/firebase-config';

const OfficesDepartments = () => {
  const [offices, setOffices] = useState([]);
  const [isOfficeModalOpen, setIsOfficeModalOpen] = useState(false);
  const [newOffice, setNewOffice] = useState({
    name: '',
    departmentId: '',
    officer: '',
    roles: '',
    workflowAddress: '',
  });

  // Fetch offices from Firestore on component mount
  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'offices'));
        const officesList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOffices(officesList);
      } catch (error) {
        console.error('Error fetching offices from Firestore: ', error);
      }
    };

    fetchOffices();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOffice((prevOffice) => ({
      ...prevOffice,
      [name]: value,
    }));
  };

  // Open the modal
  const handleCreateOffice = () => {
    setIsOfficeModalOpen(true);
  };

  // Submit new office to Firestore
  const handleOfficeSubmit = async () => {
    try {
      const newOfficeInstance = new Office({
        name: newOffice.name,
        departmentId: newOffice.departmentId,
        officer: newOffice.officer,
        roles: newOffice.roles.split(','), // Split roles if entered as comma-separated
        workflowAddress: newOffice.workflowAddress,
      });
      console.log('Saving new office:', newOfficeInstance);
      const officeRef = doc(collection(db, 'offices'));
      await setDoc(officeRef, newOfficeInstance.toFirestore());
      console.log('Office added to Firestore with ID:', officeRef.id);

      setOffices([
        ...offices,
        { id: officeRef.id, ...newOfficeInstance.toFirestore() },
      ]);
      setNewOffice({
        name: '',
        departmentId: '',
        officer: '',
        roles: '',
        workflowAddress: '',
      });
      setIsOfficeModalOpen(false);
    } catch (error) {
      console.error('Error adding office to Firestore: ', error);
    }
  };

  // Close the modal
  const closeModal = () => {
    setIsOfficeModalOpen(false);
  };

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-3xl font-semibold mb-4">Offices & Departments</h2>

      <div className="flex space-x-4 mb-6">
        <button
          onClick={handleCreateOffice}
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          Create Office
        </button>
      </div>

      <div className="mb-8">
        <h3 className="text-2xl font-semibold mb-2">Offices</h3>
        <div className="bg-gray-100 p-4 rounded shadow">
          {offices.length > 0 ? (
            <ul>
              {offices.map((office, index) => (
                <li key={index} className="py-2 border-b">
                  {office.name} - {office.departmentId}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-600">No offices created yet.</p>
          )}
        </div>
      </div>

      {/* Modal for Creating Office */}
      {isOfficeModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
            <h3 className="text-xl font-semibold mb-4">Create New Office</h3>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Office Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={newOffice.name}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Department ID
                </label>
                <input
                  type="text"
                  name="departmentId"
                  value={newOffice.departmentId}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Officer
                </label>
                <input
                  type="text"
                  name="officer"
                  value={newOffice.officer}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Roles (comma-separated)
                </label>
                <input
                  type="text"
                  name="roles"
                  value={newOffice.roles}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Workflow Address
                </label>
                <input
                  type="text"
                  name="workflowAddress"
                  value={newOffice.workflowAddress}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded"
                  required
                />
              </div>

              <div className="flex justify-end space-x-2">
                <button
                  onClick={closeModal}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={handleOfficeSubmit}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Create Office
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfficesDepartments;
